import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import React, { Component } from 'react';
import { ajax_wrapper } from 'functions';
import CheckoutForm from './checkout.js';
import { Container } from 'library';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

// Initialize with null, will load from backend
let stripePromise = null;

export default class Stripe extends Component {
    constructor(props) {
      super(props);
      this.state = {
        clientSecret: '',
        stripeLoaded: false
      };

      this.load_stripe_secret = this.load_stripe_secret.bind(this);
      this.load_stripe_key = this.load_stripe_key.bind(this);
    }

    componentDidMount() {
      // Load publishable key first
      ajax_wrapper('GET', '/api/stripe_publishable_key/', {}, this.load_stripe_key);
    }

    load_stripe_key(data) {
      // Initialize Stripe with the key from backend
      stripePromise = loadStripe(data.publishable_key);
      this.setState({stripeLoaded: true}, () => {
        // After Stripe is loaded, create the payment intent
        ajax_wrapper('POST', '/api/stripe_payment_intent/', {'price': this.props.price}, this.load_stripe_secret);
      });
    }

    load_stripe_secret(data) {
      this.setState({clientSecret: data['client_secret']})
    }

    render() {
      const { clientSecret, stripeLoaded } = this.state;

      const options = {
        clientSecret,
      };

      return (
        <Container>
          {stripeLoaded && clientSecret && (
            <Elements stripe={stripePromise} options={options}>
              <CheckoutForm />
            </Elements>
          )}
        </Container>
      );
    }
  
};



